<template>

    <div class="error-page">
        <!--<h2 class="headline text-yellow"> Demo</h2>-->

        <div class="error-content" style="padding:20px 0 0 20px;">
            <h3><i class="fa fa-warning text-yellow"></i> Demo modus actief</h3>

            <p>
                Het is niet mogelijk om deze actie uit te voeren in de demo modus!
                <router-link :to="{name:'dashboard'}">Return to dashboard</router-link>.
            </p>
        </div>
    </div>

</template>

<script>

export default {

    metaInfo: {
        title:'Demo mode',
    },

    name:'ErrorsDemoMode',

}

</script>
